import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';
import { PaymentSummary } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class PaymentSummaryApi {
    public static getPaymentSummary(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<PaymentSummary> {
        return http.get(`/payments/${params['id.key']}`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: PaymentSummary) => PaymentSummary.create<PaymentSummary>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_PAYMENT_SUMMARY] = PaymentSummaryApi.getPaymentSummary;
